module.exports = __webpack_public_path__ + "labioplastika_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_5_after.jpg
// module id = 1075
// module chunks = 0